var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNaijaLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 40,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#83bf4f",
    d: "M0 19.843c0 9.102 5.836 16.814 13.896 19.663V.18C5.836 3.029 0 10.74 0 19.843m41.688 0A20.78 20.78 0 0 0 27.791.181v39.325a20.78 20.78 0 0 0 13.895-19.663z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaijaLogo);
export default __webpack_public_path__ + "static/media/naijaLogo.5b02f9380e6dab24cc327bf376799125.svg";
export { ForwardRef as ReactComponent };